import { useState } from "react";

import { Hit } from "instantsearch.js";
import { useHotkeys } from "react-hotkeys-hook";

import { Box, Flex } from "@/components/layout/flexbox";
import { FadeInBox } from "@/components/pieces/FadeInBox";
import { JobTitleMultiselect } from "@/components/pieces/jobs/JobTitleMultiselect";
import { CtaButton } from "@/components/pieces/onboarding/CtaButton";
import { Form } from "@/components/pieces/onboarding/Form";
import { PageTitle } from "@/components/pieces/onboarding/PageTitle";
import { PopularTitles } from "@/components/pieces/onboarding/PopularTitles";
import { IntakeForm } from "@/types/users";
import { NonNullableArrayItem } from "@/utils/types";

type JobTitle = NonNullableArrayItem<NonNullable<IntakeForm["jobTitles"]>>;

interface JobTitlesProps {
  intakeForm: IntakeForm;
  loading: boolean;
  saveIntakeForm: (data: {
    jobTitles: string[];
    jobTitlesSkipped: boolean;
  }) => void;
}

export function JobTitles({
  intakeForm,
  loading,
  saveIntakeForm,
}: JobTitlesProps) {
  const [jobTitles, setJobTitles] = useState(intakeForm.jobTitles);

  function submit() {
    if (loading) return;
    saveIntakeForm({
      jobTitles: jobTitles.map((t) => t.normalizedTitle),
      jobTitlesSkipped: Object.keys(jobTitles).length === 0,
    });
  }

  useHotkeys("enter", submit);

  return (
    <Flex justifyContent="center">
      <Box width={[1, 1, 670]}>
        <FadeInBox>
          <PageTitle
            title="Which roles are relevant?"
            subtitle="Leave blank if you're not sure"
          />
          <Form onSubmit={submit}>
            <JobTitleMultiselect
              indexName="job_title_index"
              onChange={(titles) =>
                setJobTitles(titles as unknown as JobTitle[])
              }
              autoFocus={true}
              disabled={loading}
              selections={jobTitles as unknown as Hit[]}
              filters={"is_canonical:true AND usage_count >= 1000"}
            />
          </Form>

          <PopularTitles
            excludingTitles={jobTitles}
            onSelect={(pt) => setJobTitles(jobTitles.concat([pt]))}
          />

          <CtaButton loading={loading} onClick={submit} visible={true}>
            Continue
          </CtaButton>
        </FadeInBox>
      </Box>
    </Flex>
  );
}
